var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticStyle:{"position":"relative","height":"350px !important"}},[_c('line-chart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions,"styles":{ height: '100%' }}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between mb-20"},[_c('h5',{staticClass:"m-0"},[_vm._v("Collections Value")])])
}]

export { render, staticRenderFns }